import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";

import { LOCAL_CONSTANT } from "../../Const";
import {
    Box,
    Typography,
    Select,
    MenuItem,
    TextField,
    SelectChangeEvent,
    FormControl,
} from "@mui/material";
import {
    checkListDisabled,
    hasConflictSubject,
    closingTime,
    displayClosingTime,
    conflictBusinessType,
    conflict_business_type_trans_business_type,
    handleChangeValue,
    checkHidenColumn,
    business_type_value,
} from "./AddConflictFunction";
import {
    CVS_MASTER_DATA,
    SM_DRUG_MASTER_DATA,
} from "../../ResearchReport/Conflict";
import {
    changeConflictTextColor,
    changeConflictBGColor
} from "../../../data/tableFunc";
import { setSelecterDisplay } from "../../Common";
import { setDeleteRequestConflictErrorList } from "../../../features/longPageSlice";

const hours = [
    { code_value: "00", code_display: "0" },
    { code_value: "01", code_display: "1" },
    { code_value: "02", code_display: "2" },
    { code_value: "03", code_display: "3" },
    { code_value: "04", code_display: "4" },
    { code_value: "05", code_display: "5" },
    { code_value: "06", code_display: "6" },
    { code_value: "07", code_display: "7" },
    { code_value: "08", code_display: "8" },
    { code_value: "09", code_display: "9" },
    { code_value: "10", code_display: "10" },
    { code_value: "11", code_display: "11" },
    { code_value: "12", code_display: "12" },
    { code_value: "13", code_display: "13" },
    { code_value: "14", code_display: "14" },
    { code_value: "15", code_display: "15" },
    { code_value: "16", code_display: "16" },
    { code_value: "17", code_display: "17" },
    { code_value: "18", code_display: "18" },
    { code_value: "19", code_display: "19" },
    { code_value: "20", code_display: "20" },
    { code_value: "21", code_display: "21" },
    { code_value: "22", code_display: "22" },
    { code_value: "23", code_display: "23" },
];
const minutes = [
    { code_value: "00", code_display: "0" },
    { code_value: "15", code_display: "15" },
    { code_value: "30", code_display: "30" },
    { code_value: "45", code_display: "45" },
];

const BUSINESS_TYPE = [
    { value: "0", name: "SM系" },
    { value: "1", name: "DS系" },
];

export interface conflictListDetailsProps {
    props: {
        detailList: any;
        conflictData: any;
        type: string;
        codeMaster: any;
        editConflict: boolean;
        editDisabled: boolean;
        draw: boolean;
        setDraw: any;
        targetRadius: any;
        ownStore: any;
    };
}

export const ConflictListDetails: React.FC<conflictListDetailsProps> = ({ props }) => {
    const dispatch = useAppDispatch();
    // 表示色変更用BQログデータ
    const objRrBranchLog = useAppSelector((state) => state.longPage.rrBranchLog);
    // 入力チェックエラーリスト
    const objRequestErrorList = useAppSelector((state) => state.longPage.requestErrorList);
    const objDonation = useAppSelector((state) => state.donation.obj);
    
    //道なり距離～直進計判定
    const targetColumnFlag = (keyName: string) => {
        let boolean = false;
        if (keyName === "plan_area_shared_road" ||
            keyName === "plan_area_direction" ||
            keyName === "conflict_shared_road" ||
            keyName === "conflict_median_strip" ||
            keyName === "count_left_right_turns" ||
            keyName === "count_straight"
        ) {
            boolean = true;
        }
        return boolean;
    }

    //競合店　項目動的対応　グレーアウト
    const typographyGrayOut = () => {
        return {
            minHeight: "50px",
            height: "50px",
            minWidth: "240px",
            width: "240px",
            padding: "10px 0",
            border: "1px solid black",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }
    }

    // 競合店 項目動的対応 非活性
    const typographyStyle = (isUserType: boolean, labelName: string, conflictData: any) => {
        return {
            minHeight: "50px",
            height: "50px",
            minWidth: "240px",
            width: "240px",
            padding: "8px 4px",
            border: "1px solid black",
            fontSize: "0.875rem",
            wordBreak: "break-word",
            textOverflow: "ellipsis",
            color: changeConflictTextColor(
                objRrBranchLog,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence
            ),
            backgroundColor: changeConflictBGColor(
                isUserType,
                objRequestErrorList,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence,
                conflictData[labelName],
                conflictData.market_cut
            ),
        }
    };

    // 競合自店 項目動的対応 活性
    const textFiledStyle = (labelName: string, conflictData: any, disabled: string) => {
        const isUserType = checkEditDisabled(conflictData, disabled);
        return {
            minHeight: "50px",
            height: "50px",
            minWidth: "240px",
            width: "240px",
            maxWidth: "240px",
            border: "1px solid black",
            color: changeConflictTextColor(
                objRrBranchLog,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence
            ),
            backgroundColor: changeConflictBGColor(
                isUserType,
                objRequestErrorList,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence,
                conflictData[labelName],
                conflictData.market_cut
            ),
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
                height: "50px",
            },
            "& input": {
                padding: "8px 4px",
                fontSize: "0.875rem",
            },
        }
    };

    // 競合店 プルダウン 項目動的対応　活性
    const selectStyle = (labelName: string, conflictData: any, disabled: string) => {
        const isUserType = checkEditDisabled(conflictData, disabled);
        return {
            minHeight: "50px",
            height: "50px",
            minWidth: "240px",
            width: "240px",
            maxWidth: "240px",
            border: "1px solid black",
            fontSize: "0.875rem",
            color: changeConflictTextColor(
                objRrBranchLog,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence
            ),
            backgroundColor: changeConflictBGColor(
                isUserType,
                objRequestErrorList,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence,
                conflictData[labelName],
                conflictData.market_cut
            )
        }
    };

    // 競合店 プルダウン 項目動的対応 閉店時間
    const selectClosingTimeStyle = (labelName: string, conflictData: any, disabled: string) => {
        const isUserType = checkEditDisabled(conflictData, disabled);
        return {
            width: "50%",
            border: "1px solid black",
            color: changeConflictTextColor(
                objRrBranchLog,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence
            ),
            backgroundColor: changeConflictBGColor(
                isUserType,
                objRequestErrorList,
                LOCAL_CONSTANT.NAVI.CONFLICT,
                labelName,
                conflictData.conflict_type,
                conflictData.conflict_sequence,
                conflictData[labelName],
                conflictData.market_cut
            )
        }
    };

    const checkEditDisabled = (data: any, columnDisabled: string) => {
        let disabled = false;
        if (props.editDisabled) {
            disabled = true;
        } else {
            if (columnDisabled !== "") {
                disabled = checkListDisabled(data, columnDisabled, objDonation);
            }
        }
        return disabled;
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        data: any,
        labelName: string
    ) => {
        data = handleChangeValue(e, data, labelName)
        data["conflict_business_type"] = conflictBusinessType(
            data,
            data["business_type"]
        );
        props.setDraw(!props.draw);
    };

    const handleBlur = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        data: any,
        labelName: string
    ) => {
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestConflictErrorList({
                    column: labelName,
                    conflictData: data
                })
            );
    };

    const handleSelectedChange = (
        e: SelectChangeEvent<string>,
        data: any,
        labelName: string
    ) => {
        data[labelName] = e.target.value;
        if (labelName === "location") {
            const side_road_type = ["0", "1", "2", "3"];
            data["side_road_type"] = side_road_type[data[labelName]];
        }
        props.setDraw(!props.draw);
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestConflictErrorList({
                    column: labelName,
                    conflictData: data
                })
            );
    };

    const handleSelectedClosingTime = (
        e: SelectChangeEvent<string>,
        key: string,
        data: any,
        labelName: string
    ) => {
        let hours = data[labelName].slice(0, 2);
        let minutes = data[labelName].slice(2, 4);
        if (key === "hours") {
            data[labelName] = e.target.value + minutes;
        } else {
            data[labelName] = hours + e.target.value;
        }
        props.setDraw(!props.draw);
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(
                setDeleteRequestConflictErrorList({
                    column: labelName,
                    conflictData: data
                })
            );
    };


    const displayLocationConflictType = (data: any) => {
        if (props.type === SM_DRUG_MASTER_DATA) {
            data["business_type"] = conflict_business_type_trans_business_type(
                data["conflict_business_type"]
            );
        }

        data.location_conflict_type = hasConflictSubject(
            data,
            data,
            props.targetRadius,
            props.type,
            props.ownStore,
            "list",
            objDonation,
        );

        return setSelecterDisplay(
            props.codeMaster["location_conflict_type"],
            data.location_conflict_type
        );
    };

    const selectClosingTime = (date: any, key: string) => {
        const result = closingTime(date);
        if (key === "hours") {
            return result.hours;
        }
        return result.minutes;
    };

    const setBusinessTypeValue = (conflictData: any, editFlag: boolean) => {
        if(
            conflictData["conflict_business_type"] === "1" ||
            conflictData["conflict_business_type"] === "2" ||
            conflictData["conflict_business_type"] === "3" 
        ){
            return "SM系";
        } else {
            return "DS系";
        }
    };

    //業種タイプ変更
    const handleBusinessTypeChange = (conflictData: any, e: SelectChangeEvent<string>) => {
        let conflict_business_type = "";
        if (Number(conflictData["sales_floor_area_size"]) < 500) {
            if (e.target.value === "0") {
                conflict_business_type = "1";
            } else if (e.target.value === "1") {
                conflict_business_type = "4";
            }
        } else if (Number(conflictData["sales_floor_area_size"]) < 6600) {
            if (e.target.value === "0") {
                conflict_business_type = "2";
            } else if (e.target.value === "1") {
                conflict_business_type = "5";
            }
        } else if (Number(conflictData["sales_floor_area_size"]) >= 6600) {
            if (e.target.value === "0") {
                conflict_business_type = "3";
            } else if (e.target.value === "1") {
                conflict_business_type = "6";
            }
        }
        conflictData["conflict_business_type"] = conflict_business_type;
        conflictData["business_type"] = e.target.value;
        props.setDraw(!props.draw);
    };

    //業態名セット
    const setConflictBussinessTypeName = (conflictData: any) => {
        let conflict_business_type_name = "";
        switch(conflictData["conflict_business_type"]){
            case "1":
                conflict_business_type_name ="ミニSM"; break
            case "2":
                conflict_business_type_name ="SM"; break
            case "3":
                conflict_business_type_name ="GMS"; break
            case "4":
                conflict_business_type_name ="ミニDS"; break
            case "5":
                conflict_business_type_name ="DS"; break
            case "6":
                conflict_business_type_name ="大規模DS"; break
        }
        return conflict_business_type_name;
    };


    // 固定表示項目(店名までの項目)を判定する関数
    const isFixedItem = (key: number, type: string) => {
        if (type === "cvs-master-data") {
            return key <= 4; // CVSの場合、key 4（店名）まで
        } else {
            return key <= 6; // SM/DSの場合、key 6（店名）まで
        }
    };

    // 固定表示項目をフィルタリング
    const fixedItems = props.detailList.filter((column: any) => 
        isFixedItem(column.key, props.type)
    );

    // スクロール可能項目をフィルタリング
    const scrollableItems = props.detailList.filter((column: any) => 
        !isFixedItem(column.key, props.type)
    );

    return (
        <>
            {/* 固定表示部分 */}
            {fixedItems.map((column: any) => (
                <Box
                    sx={{
                        display: checkHidenColumn(
                            "columnList",
                            column.key,
                            props.type
                        )
                            ? "none"
                            : "flex",
                    }}
                    key={column.key}
                >
                    {props.conflictData.map(
                        (conflict: any, conflictIndex: any) => (
                            <Box
                                key={
                                    conflictIndex +
                                    "-" +
                                    column.key +
                                    "-" +
                                    column.keyName +
                                    "-" +
                                    conflict.conflict_sequence
                                }
                            >
                                {/** 競合店データを表示 */}
                                {column.type ===
                                    "codemaster-value" && (
                                        <Typography
                                            sx={typographyStyle(
                                                true,
                                                column.keyName,
                                                conflict
                                            )}
                                        >
                                            {setSelecterDisplay(
                                                props.codeMaster[column.keyName],
                                                conflict[column.keyName]
                                            )}
                                        </Typography>
                                    )}
                                {column.type === "label" && (
                                    <Typography
                                        sx={{
                                            minHeight: "50px",
                                            height: "50px",
                                            minWidth: "180px",
                                            width: "180px",
                                            maxWidth: "180px",
                                            padding: "8px 4px",
                                            border: "1px solid black",
                                            fontSize: "0.875rem",
                                            wordBreak: "break-word",
                                            textOverflow: "ellipsis",
                                            backgroundColor:
                                                "rgba(0, 0, 0, 0.06)",
                                        }}
                                    >
                                        {
                                            conflict[
                                            column.keyName
                                            ]
                                        }
                                    </Typography>
                                )}
                                {props.editConflict === false &&
                                    column.type === "round" && (
                                        <Typography
                                            sx={typographyStyle(
                                                true,
                                                column.keyName,
                                                conflict
                                            )}
                                        >
                                            {conflict[
                                                column.keyName
                                            ] === ""
                                                ? ""
                                                : Math.round(
                                                    conflict[
                                                    column
                                                        .keyName
                                                    ] * 100
                                                ) / 100}
                                        </Typography>
                                    )}
                                {props.editConflict === true &&
                                    column.type === "round" && (
                                        <TextField
                                            disabled={checkEditDisabled(
                                                conflict,
                                                column.disabled
                                            )}
                                            sx={textFiledStyle(
                                                column.keyName,
                                                conflict,
                                                column.disabled
                                            )}
                                            onChange={(e) => {
                                                handleChange(
                                                    e,
                                                    conflict,
                                                    column.keyName
                                                );
                                            }}
                                            onBlur={(e) => {
                                                handleBlur(
                                                    e,
                                                    conflict,
                                                    column.keyName
                                                );
                                            }}
                                            value={
                                                conflict[
                                                column
                                                    .keyName
                                                ]
                                            }
                                        ></TextField>
                                    )}
                                {column.type ===
                                    "location_conflict_type" && (
                                        <Typography
                                            sx={typographyStyle(
                                                true,
                                                column.keyName,
                                                conflict
                                            )}
                                        >
                                            {
                                                props.editConflict === false &&
                                                setSelecterDisplay(
                                                    props.codeMaster["location_conflict_type"],
                                                    conflict.location_conflict_type
                                                )
                                            }
                                            {
                                                props.editConflict === true &&
                                                displayLocationConflictType(conflict)
                                            }
                                        </Typography>
                                    )}
                                {props.editConflict === false &&
                                    column.type ===
                                        "business_type" && (
                                            <Typography
                                                sx={typographyStyle(
                                                    true,
                                                    column.keyName,
                                                    conflict
                                                )}
                                            >
                                                {setBusinessTypeValue(
                                                    conflict, 
                                                    props.editConflict
                                                )}
                                            </Typography>
                                )}
                                {props.editConflict === true &&
                                    column.type ===
                                        "business_type" && (
                                            <Select
                                                sx={selectStyle(
                                                    column.keyName,
                                                    conflict,
                                                    column.disabled
                                                )}
                                                onChange={(e) =>
                                                    handleBusinessTypeChange(
                                                        conflict,
                                                        e
                                                    )
                                                }
                                                value={conflict["business_type"]}
                                                disabled={checkEditDisabled(
                                                    conflict,
                                                    column.disabled
                                                )}
                                            >
                                                {BUSINESS_TYPE.map((row: any) => (
                                                    <MenuItem
                                                        key={row.value}
                                                        value={row.value}
                                                    >
                                                        {row.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                )}
                                {column.type ===
                                    "conflict_business_type" && (
                                        <Typography
                                            sx={typographyStyle(
                                                true,
                                                column.keyName,
                                                conflict
                                            )}
                                        >
                                            {setConflictBussinessTypeName(conflict)}
                                        </Typography>
                                )}
                                {props.editConflict === false &&
                                    column.type === "text" && (
                                        <Typography
                                            sx={typographyStyle(
                                                true,
                                                column.keyName,
                                                conflict
                                            )}
                                        >
                                            {
                                                conflict[
                                                column
                                                    .keyName
                                                ]
                                            }
                                        </Typography>
                                    )}
                                {props.editConflict === true &&
                                    column.type === "text" && (
                                        <TextField
                                            disabled={checkEditDisabled(
                                                conflict,
                                                column.disabled
                                            )}
                                            sx={textFiledStyle(
                                                column.keyName,
                                                conflict,
                                                column.disabled
                                            )}
                                            onChange={(e) => {
                                                handleChange(
                                                    e,
                                                    conflict,
                                                    column.keyName
                                                );
                                            }}
                                            onBlur={(e) => {
                                                handleBlur(
                                                    e,
                                                    conflict,
                                                    column.keyName
                                                );
                                            }}
                                            value={
                                                conflict[
                                                column
                                                    .keyName
                                                ]
                                            }
                                        ></TextField>
                                    )}
                                {props.editConflict === false &&
                                    column.type ===
                                    "time-label" && (
                                        <>
                                            {conflict["business_hours"] === "0" && (
                                                <Typography
                                                    sx={typographyStyle(
                                                        true,
                                                        column.keyName,
                                                        conflict
                                                    )}
                                                >
                                                    {displayClosingTime(
                                                        conflict[
                                                        column
                                                            .keyName
                                                        ],
                                                        true
                                                    )}
                                                </Typography>
                                            )}
                                            {(conflict["business_hours"] === "" || conflict["business_hours"] === "1") && (
                                                <Typography
                                                    sx={typographyGrayOut}
                                                ></Typography>
                                            )}
                                        </>
                                    )}
                                {props.editConflict === true &&
                                    column.type ===
                                    "time-label" && (
                                    <>
                                        {(conflict["business_hours"] === "" || conflict["business_hours"] === "1") && (
                                            <Typography
                                                sx={typographyGrayOut}
                                            ></Typography>
                                        )}
                                        {conflict["business_hours"] === "0" && (
                                            <FormControl
                                                disabled={checkEditDisabled(
                                                    conflict,
                                                    column.disabled
                                                )}
                                            >
                                                <Box
                                                    sx={{
                                                        minHeight:
                                                            "50px",
                                                        height: "50px",
                                                        minWidth:
                                                            "240px",
                                                        width: "240px",
                                                    }}
                                                >
                                                    <Select
                                                        sx={selectClosingTimeStyle(
                                                            column.keyName,
                                                            conflict,
                                                            column.disabled
                                                        )}
                                                        onChange={(
                                                            e
                                                        ) =>
                                                            handleSelectedClosingTime(
                                                                e,
                                                                "hours",
                                                                conflict,
                                                                column.keyName
                                                            )
                                                        }
                                                        value={selectClosingTime(
                                                            conflict[column.keyName],
                                                            "hours"
                                                        )}
                                                    >
                                                        {hours.map(
                                                            (
                                                                row: any
                                                            ) => (
                                                                <MenuItem
                                                                    key={
                                                                        row.code_value
                                                                    }
                                                                    value={
                                                                        row.code_value
                                                                    }
                                                                >
                                                                    {
                                                                        row.code_display
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                    <Select
                                                        sx={selectClosingTimeStyle(
                                                            column.keyName,
                                                            conflict,
                                                            column.disabled
                                                        )}
                                                        onChange={(
                                                            e
                                                        ) =>
                                                            handleSelectedClosingTime(
                                                                e,
                                                                "minutes",
                                                                conflict,
                                                                column.keyName
                                                            )
                                                        }
                                                        value={selectClosingTime(
                                                            conflict[
                                                            column
                                                                .keyName
                                                            ],
                                                            "minutes"
                                                        )}
                                                    >
                                                        {minutes.map((row: any) => (
                                                            <MenuItem
                                                                key={row.code_value}
                                                                value={row.code_value}
                                                            >
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                        )}
                                                    </Select>
                                                </Box>
                                            </FormControl>
                                        )}
                                    </>
                                )}
                                {props.editConflict === false &&
                                    column.type ===
                                    "select" && (
                                        <Typography
                                            sx={typographyStyle(
                                                true,
                                                column.keyName,
                                                conflict
                                            )}
                                        >
                                            {setSelecterDisplay(
                                                props.codeMaster[column.SELECT_KEY],
                                                conflict[column.keyName]
                                            )}
                                        </Typography>
                                    )}
                                {props.editConflict === true &&
                                    column.type ===
                                    "select" && (
                                        <FormControl
                                            disabled={checkEditDisabled(
                                                conflict,
                                                column.disabled
                                            )}
                                        >
                                            <Select
                                                onChange={(e) =>
                                                    handleSelectedChange(
                                                        e,
                                                        conflict,
                                                        column.keyName
                                                    )
                                                }
                                                sx={selectStyle(
                                                    column.keyName,
                                                    conflict,
                                                    column.disabled
                                                )}
                                                value={
                                                    conflict[
                                                    column
                                                        .keyName
                                                    ]
                                                }
                                            >
                                                {props.codeMaster?.[column.SELECT_KEY].map(
                                                    (data: any) => (
                                                        <MenuItem
                                                            key={
                                                                data.code_value
                                                            }
                                                            value={
                                                                data.code_value
                                                            }
                                                        >
                                                            {
                                                                data.code_display
                                                            }
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                    )}
                            </Box>
                        )
                    )}
                </Box>
            ))}

            {/* スクロール可能部分 */}
            <Box
                sx={{
                    maxHeight: props.type === CVS_MASTER_DATA ? "355px":"305px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    width: "100%",
                }}
                id={"conflictDetailsScrollRef" + props.type}
            >
                {scrollableItems.map((column: any) => (
                    <Box
                        sx={{
                            display: checkHidenColumn(
                                "columnList",
                                column.key,
                                props.type
                            )
                                ? "none"
                                : "flex",
                        }}
                        key={column.key}
                    >
                        {props.conflictData.map(
                            (conflict: any, conflictIndex: any) => (
                                <Box
                                    key={
                                        conflictIndex +
                                        "-" +
                                        column.key +
                                        "-" +
                                        column.keyName +
                                        "-" +
                                        conflict.conflict_sequence
                                    }
                                >
                                    {/** 競合店データを表示 */}
                                    {column.type ===
                                        "codemaster-value" && (
                                            <Typography
                                                sx={typographyStyle(
                                                    true,
                                                    column.keyName,
                                                    conflict
                                                )}
                                            >
                                                {setSelecterDisplay(
                                                    props.codeMaster[column.keyName],
                                                    conflict[column.keyName]
                                                )}
                                            </Typography>
                                        )}
                                    {column.type === "label" && (
                                        <Typography
                                            sx={{
                                                minHeight: "50px",
                                                height: "50px",
                                                minWidth: "180px",
                                                width: "180px",
                                                maxWidth: "180px",
                                                padding: "8px 4px",
                                                border: "1px solid black",
                                                fontSize: "0.875rem",
                                                wordBreak: "break-word",
                                                textOverflow: "ellipsis",
                                                backgroundColor:
                                                    "rgba(0, 0, 0, 0.06)",
                                            }}
                                        >
                                            {
                                                conflict[
                                                column.keyName
                                                ]
                                            }
                                        </Typography>
                                    )}
                                    {props.editConflict === false &&
                                        column.type === "round" && (
                                            (column.keyName === "road_distance" &&
                                            checkListDisabled(
                                                conflict,
                                                column.disabled,
                                                objDonation
                                            )) ? (
                                                <Typography
                                                    sx={typographyGrayOut}
                                                ></Typography>
                                            ) : (
                                                <Typography
                                                    sx={typographyStyle(
                                                        true,
                                                        column.keyName,
                                                        conflict
                                                    )}
                                                >
                                                    {conflict[
                                                        column.keyName
                                                    ] === ""
                                                        ? ""
                                                        : Math.round(
                                                            conflict[
                                                            column
                                                                .keyName
                                                            ] * 100
                                                        ) / 100}
                                                </Typography>
                                            )
                                        )}
                                    {props.editConflict === true &&
                                        column.type === "round" && (
                                            <TextField
                                                disabled={checkEditDisabled(
                                                    conflict,
                                                    column.disabled
                                                )}
                                                sx={textFiledStyle(
                                                    column.keyName,
                                                    conflict,
                                                    column.disabled
                                                )}
                                                onChange={(e) => {
                                                    handleChange(
                                                        e,
                                                        conflict,
                                                        column.keyName
                                                    );
                                                }}
                                                onBlur={(e) => {
                                                    handleBlur(
                                                        e,
                                                        conflict,
                                                        column.keyName
                                                    );
                                                }}
                                                value={
                                                    conflict[
                                                    column
                                                        .keyName
                                                    ]
                                                }
                                            ></TextField>
                                        )}
                                    {column.type ===
                                        "location_conflict_type" && (
                                            <Typography
                                                sx={typographyStyle(
                                                    true,
                                                    column.keyName,
                                                    conflict
                                                )}
                                            >
                                                {
                                                    props.editConflict === false &&
                                                    setSelecterDisplay(
                                                        props.codeMaster["location_conflict_type"],
                                                        conflict.location_conflict_type
                                                    )
                                                }
                                                {
                                                    props.editConflict === true &&
                                                    displayLocationConflictType(conflict)
                                                }
                                            </Typography>
                                        )}
                                    {props.editConflict === false &&
                                        column.type ===
                                            "business_type" && (
                                                <Typography
                                                    sx={typographyStyle(
                                                        true,
                                                        column.keyName,
                                                        conflict
                                                    )}
                                                >
                                                    {setBusinessTypeValue(
                                                        conflict, 
                                                        props.editConflict
                                                    )}
                                                </Typography>
                                        )}
                                    {props.editConflict === true &&
                                        column.type ===
                                            "business_type" && (
                                                <Select
                                                    sx={selectStyle(
                                                        column.keyName,
                                                        conflict,
                                                        column.disabled
                                                    )}
                                                    onChange={(e) =>
                                                        handleBusinessTypeChange(
                                                            conflict,
                                                            e
                                                        )
                                                    }
                                                    value={conflict["business_type"]}
                                                    disabled={checkEditDisabled(
                                                        conflict,
                                                        column.disabled
                                                    )}
                                                >
                                                    {BUSINESS_TYPE.map((row: any) => (
                                                        <MenuItem
                                                            key={row.value}
                                                            value={row.value}
                                                        >
                                                            {row.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                        )}
                                    {column.type ===
                                        "conflict_business_type" && (
                                            <Typography
                                                sx={typographyStyle(
                                                    true,
                                                    column.keyName,
                                                    conflict
                                                )}
                                            >
                                                {setConflictBussinessTypeName(conflict)}
                                            </Typography>
                                        )}
                                    {props.editConflict === false &&
                                        column.type === "text" && (
                                            <Typography
                                                sx={typographyStyle(
                                                    true,
                                                    column.keyName,
                                                    conflict
                                                )}
                                            >
                                                {
                                                    conflict[
                                                    column
                                                        .keyName
                                                    ]
                                                }
                                            </Typography>
                                        )}
                                    {props.editConflict === true &&
                                        column.type === "text" && (
                                            <TextField
                                                disabled={checkEditDisabled(
                                                    conflict,
                                                    column.disabled
                                                )}
                                                sx={textFiledStyle(
                                                    column.keyName,
                                                    conflict,
                                                    column.disabled
                                                )}
                                                onChange={(e) => {
                                                    handleChange(
                                                        e,
                                                        conflict,
                                                        column.keyName
                                                    );
                                                }}
                                                onBlur={(e) => {
                                                    handleBlur(
                                                        e,
                                                        conflict,
                                                        column.keyName
                                                    );
                                                }}
                                                value={
                                                    conflict[
                                                    column
                                                        .keyName
                                                    ]
                                                }
                                            ></TextField>
                                        )}
                                    {props.editConflict === false &&
                                        column.type ===
                                        "time-label" && (
                                            <>
                                                {conflict["business_hours"] === "0" && (
                                                    <Typography
                                                        sx={typographyStyle(
                                                            true,
                                                            column.keyName,
                                                            conflict
                                                        )}
                                                    >
                                                        {displayClosingTime(
                                                            conflict[
                                                            column
                                                                .keyName
                                                            ],
                                                            true
                                                        )}
                                                    </Typography>
                                                )}
                                                {(conflict["business_hours"] === "" || conflict["business_hours"] === "1") && (
                                                    <Typography
                                                        sx={typographyGrayOut}
                                                    ></Typography>
                                                )}
                                            </>
                                        )}
                                    {props.editConflict === true &&
                                        column.type ===
                                        "time-label" && (
                                        <>
                                            {(conflict["business_hours"] === "" || conflict["business_hours"] === "1") && (
                                                <Typography
                                                    sx={typographyGrayOut}
                                                ></Typography>
                                            )}
                                            {conflict["business_hours"] === "0" && (
                                                <FormControl
                                                    disabled={checkEditDisabled(
                                                        conflict,
                                                        column.disabled
                                                    )}
                                                >
                                                    <Box
                                                        sx={{
                                                            minHeight:
                                                                "50px",
                                                            height: "50px",
                                                            minWidth:
                                                                "240px",
                                                            width: "240px",
                                                        }}
                                                    >
                                                        <Select
                                                            sx={selectClosingTimeStyle(
                                                                column.keyName,
                                                                conflict,
                                                                column.disabled
                                                            )}
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                handleSelectedClosingTime(
                                                                    e,
                                                                    "hours",
                                                                    conflict,
                                                                    column.keyName
                                                                )
                                                            }
                                                            value={selectClosingTime(
                                                                conflict[column.keyName],
                                                                "hours"
                                                            )}
                                                        >
                                                            {hours.map(
                                                                (
                                                                    row: any
                                                                ) => (
                                                                    <MenuItem
                                                                        key={
                                                                            row.code_value
                                                                        }
                                                                        value={
                                                                            row.code_value
                                                                        }
                                                                    >
                                                                        {
                                                                            row.code_display
                                                                        }
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </Select>
                                                        <Select
                                                            sx={selectClosingTimeStyle(
                                                                column.keyName,
                                                                conflict,
                                                                column.disabled
                                                            )}
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                handleSelectedClosingTime(
                                                                    e,
                                                                    "minutes",
                                                                    conflict,
                                                                    column.keyName
                                                                )
                                                            }
                                                            value={selectClosingTime(
                                                                conflict[
                                                                column
                                                                    .keyName
                                                                ],
                                                                "minutes"
                                                            )}
                                                        >
                                                            {minutes.map((row: any) => (
                                                                <MenuItem
                                                                    key={row.code_value}
                                                                    value={row.code_value}
                                                                >
                                                                    {row.code_display}
                                                                </MenuItem>
                                                            )
                                                            )}
                                                        </Select>
                                                    </Box>
                                                </FormControl>
                                            )}
                                        </>
                                    )}
                                    {props.editConflict === false &&
                                        column.type ===
                                        "select" && (
                                            (targetColumnFlag(column.keyName) &&
                                            checkListDisabled(
                                                conflict,
                                                column.disabled,
                                                objDonation
                                            )) ? (
                                                <Typography
                                                    sx={typographyGrayOut}
                                                ></Typography>
                                            ) : (
                                                <Typography
                                                    sx={typographyStyle(
                                                        true,
                                                        column.keyName,
                                                        conflict
                                                    )}
                                                >
                                                    {setSelecterDisplay(
                                                        props.codeMaster[column.SELECT_KEY],
                                                        conflict[column.keyName]
                                                    )}
                                                </Typography>
                                            )
                                        )}
                                    {props.editConflict === true &&
                                        column.type ===
                                        "select" && (
                                            <FormControl
                                                disabled={checkEditDisabled(
                                                    conflict,
                                                    column.disabled
                                                )}
                                            >
                                                <Select
                                                    onChange={(e) =>
                                                        handleSelectedChange(
                                                            e,
                                                            conflict,
                                                            column.keyName
                                                        )
                                                    }
                                                    sx={selectStyle(
                                                        column.keyName,
                                                        conflict,
                                                        column.disabled
                                                    )}
                                                    value={
                                                        conflict[
                                                        column
                                                            .keyName
                                                        ]
                                                    }
                                                >
                                                    {props.codeMaster?.[column.SELECT_KEY].map(
                                                        (data: any) => (
                                                            <MenuItem
                                                                key={
                                                                    data.code_value
                                                                }
                                                                value={
                                                                    data.code_value
                                                                }
                                                            >
                                                                {
                                                                    data.code_display
                                                                }
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                </Box>
                            )
                        )}
                    </Box>
                ))}
            </Box>
        </>
    )
}

export default ConflictListDetails
